"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DataScrubbersByType = void 0;

var _Types = require("../Types");

var _dataScrubberForInt = _interopRequireDefault(require("./dataScrubberForInt"));

var _dataScrubberForFloat = _interopRequireDefault(require("./dataScrubberForFloat"));

var _dataScrubberForIntPositive = _interopRequireDefault(require("./dataScrubberForIntPositive"));

var _DataScrubbersByType;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var DataScrubbersByType = (_DataScrubbersByType = {}, _defineProperty(_DataScrubbersByType, _Types.Types.Double, function (value) {
  return (0, _dataScrubberForFloat["default"])(value);
}), _defineProperty(_DataScrubbersByType, _Types.Types.Int16, function (value) {
  return (0, _dataScrubberForInt["default"])(value);
}), _defineProperty(_DataScrubbersByType, _Types.Types.Int32, function (value) {
  return (0, _dataScrubberForInt["default"])(value);
}), _defineProperty(_DataScrubbersByType, _Types.Types.Int32Positive, function (value) {
  return (0, _dataScrubberForIntPositive["default"])(value);
}), _defineProperty(_DataScrubbersByType, _Types.Types.Int64, function (value) {
  return (0, _dataScrubberForInt["default"])(value);
}), _defineProperty(_DataScrubbersByType, _Types.Types.Single, function (value) {
  return (0, _dataScrubberForFloat["default"])(value);
}), _DataScrubbersByType);
exports.DataScrubbersByType = DataScrubbersByType;